import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  signupForm: FormGroup;

  constructor(public router: Router, private authService: AuthenticationService) {}

  ngOnInit() {
    this.signupForm = new FormGroup({
      firstname: new FormControl(''),
      lastname: new FormControl(''),
      email: new FormControl(''),
      country: new FormControl(''),
      company: new FormControl(''),
      password: new FormControl(''),
      confirmPassword: new FormControl(''),
      terms: new FormControl(false)
    });
  }

  async onSignup() {
    const data = this.signupForm.value;
    if (!data.terms || data.password !== data.confirmPassword) return;
    try {
      await this.authService.signUp(
        data.firstname,
        data.lastname,
        data.email,
        data.password,
        data.company
      );
      this.router.navigate(['/iq/personality']);
    } catch (err) {
      console.error('Signup failed:', err);
    }
  }
}
